<div class="content-area">

  <!--<p-tabView class="appointments-tab-outer" [activeIndex]="index" (onChange)="handleChange($event)">-->
  <div class="appointments-tab-outer">
    <div class="title-block">
      <h1>{{title}} </h1>
      <p class="janos-name">
        You searched for <strong> "{{searchText}}"</strong>
      </p>
    </div>
    <div class="appointments-table-filer">
      <div class="appointments-table-filer__appit-legend">
        <ul>
          <li><span class="legend ready-for-scheduling"> Ready For Scheduling</span></li>
          <li><span class="legend upcoming"> Upcoming</span></li>
          <li><span class="legend no-show"> No Show</span></li>
          <!--<li><span class="legend complete"> Complete </span></li>-->
          <li><span class="legend cancel"> Cancel</span></li>
          <li><span class="legend voidreview">Potential Void</span></li>
          <li><span class="legend void">Void</span></li>
          <li><span class="legend complete">Complete</span></li>
        </ul>
      </div>

      <div class="appointments-table-filer__sort-by">
        <a href="javascript:void(0);" class="filter-block" (click)="NotScheduledAddColumn.toggle($event)" pTooltip="Column Display Settings" tooltipPosition="left">
          <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.0525 2.89474H15.2104" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.4211 1V4.78946" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.421 2.89474H1" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4.78946 9.5263H1" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.57886 7.63157V11.421" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18.9999 9.5263H8.57886" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18.0525 16.1579H15.2104" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.4211 14.2631V18.0526" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.421 16.1579H1" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>                
        </a>
      </div>
    </div>
    <div>
      <!--<app-not-scheduled-appointments></app-not-scheduled-appointments>-->
      <!--<ng-template pTemplate="content">-->

      <div class="page-scroll appointments-list app-not-scheduled-list">
        <div class="appointments-scroll-inner-side">
          <!-- <div class="appointment-actionmenu add-table-column" *ngIf="totalRecords > 0">
            <a href="javascript:void(0)" (click)="NotScheduledAddColumn.toggle($event)">
              <i class="ic add-column"></i>
            </a>
          </div> -->

          <p-table #table [ngClass]="isOnlyFixedColumnVisible ? 'onlyvisiblecolumn' : ''"
            class="table-outer appt-not-scheduled"
            sortMode="single" [sortOrder]="1" sortField="crmPatientName" [paginator]="totalRecords>0?true:false"
            [rows]="getTotalRows()" [totalRecords]="totalRecords" [lazy]="true" [customSort]="true"
            [first]="searchRequestModel.FirstRecordIndex" [value]="salesOrders" (onLazyLoad)="onLazyLoad($event)"
            [(selection)]="selectedsalesOrders" selectionMode="" (selectionChange)="onSelectionChange($event)"
            [columns]="userPreferenceColumn" [frozenColumns]="frozencols" [scrollable]="true" scrollHeight="calc(100vh - 297px)"
            dataKey="crmSalesOrderId" scrollDirection="both">
            
            
              <ng-template pTemplate="header" let-columns>
                <tr *ngIf="totalRecords > 0">
                  <th class="table-outer__th appt-action-column" pFrozenColumn></th>
                  <th class="table-outer__th appt-so-id" pFrozenColumn>
                    <span class="header-soid__name">S/O ID</span>
                  </th>
                  <th class="table-outer__th appt-patient-name" pFrozenColumn pSortableColumn="crmPatientName">Patient
                    details
                    <p-sortIcon field="crmPatientName"></p-sortIcon>
                  </th>
                  <th class="table-outer__th appt-classification" pFrozenColumn pSortableColumn="crmClassification">Classification Type
                    <p-sortIcon field="crmClassification"></p-sortIcon>
                  </th>
                  <th class="table-outer__th appt-status" pFrozenColumn pSortableColumn="crmSalesorderStatus">Status
                    <p-sortIcon field="crmSalesorderStatus"></p-sortIcon>
                  </th>
                  <ng-container *ngFor="let co of columns">
                    <th *ngIf="co.field != 'crmPatientName && crmClassification && crmSalesorderStatus' && co.visible===true"
                      class="table-outer__th" pSortableColumn="{{co.sortFieldName}}">{{co.header}}
                      <p-sortIcon field="{{co.sortFieldName}}"></p-sortIcon>
                    </th>
                  </ng-container>
                </tr>
              </ng-template>
              
              <ng-template pTemplate="body" let-salesorder let-columns="columns">
                <tr>
                  <td class="table-outer__td appt-action-column" pFrozenColumn>
                    <a class="actionmenu-btn" href="javascript:void(0)"  *ngIf="!salesorder.isStatusCompleted" 
                      (click)="selectNonScheduleSalesOrder($event,salesorder,NotScheduledAction)">
                      <svg id="Layer_1" class="appt-action-icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 29.96 122.88">
                        <path class="cls-1"
                          d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Zm0,92.93a15,15,0,1,1-15,15,15,15,0,0,1,15-15Zm0-46.47a15,15,0,1,1-15,15,15,15,0,0,1,15-15Z" />
                      </svg>
                    </a>

                    <p-overlayPanel class="table-action-popup NotScheduledAction appointment-Action" 
                      #NotScheduledAction>
                      <ul class="quick-link-menu">
                        <li *ngIf="isAppointmentScheduledPermission  && selectedSalesOrder.appointmentId==0">
                          <a href="javascript:void(0)"
                             (click)="showDialog(selectedSalesOrder,selectedSalesOrder.appointmentId)">
                            <i class="schedule-new"></i>Schedule
                          </a>
                        </li>
                        <li *ngIf="isAppointmentRescheduledPermission && selectedSalesOrder.appointmentId>0">
                          <a href="javascript:void(0)"
                             (click)="showAppointmentDialog(selectedSalesOrder.crmSalesOrderId,selectedSalesOrder.appointmentId)">
                            <i class="schedule-new"></i>Reschedule
                          </a>
                        </li>
                        <li *ngIf="isAppointmentCancelPermission && selectedSalesOrder.appointmentId>0 && selectedSalesOrder.crmSalesorderStatus!='Cancel'">
                          <a href="javascript:void(0)"
                             (click)="showCancelAppointment(selectedSalesOrder.appointmentId)">
                            <i class="cancel-new"></i>Cancel
                          </a>
                        </li>

                        <li *ngIf="selectedSalesOrder.appointmentId==0 && selectedSalesOrder.crmSalesorderStatus != 'No Show' && selectedSalesOrder.crmSalesorderStatus != 'Cancel'">
                          <a href="javascript:void(0)" (click)="showVoidSalesOrder('A',selectedSalesOrder.crmSalesOrderId)">
                            <i class="void-new"></i>Void Review
                          </a>
                        </li>
                        <li *ngIf="selectedSalesOrder.appointmentId==0 && selectedSalesOrder.crmSalesorderStatus != 'No Show' && selectedSalesOrder.crmSalesorderStatus != 'Cancel'">
                          <a href="javascript:void(0)" (click)="showVoidSalesOrder('P',selectedSalesOrder.crmSalesOrderId)">
                            <i class="void-new"></i>Void
                          </a>
                        </li>
                      
                        <li *ngIf="selectedSalesOrder.appointmentId>0 && (selectedSalesOrder.crmSalesorderStatus == 'No Show' || selectedSalesOrder.crmSalesorderStatus == 'Cancel')">
                          <a href="javascript:void(0)" (click)="showVoidAppointment('A',selectedSalesOrder.appointmentId)">
                            <i class="void-new"></i>Void Review
                          </a>
                        </li>
                        <li *ngIf="selectedSalesOrder.appointmentId>0 &&  (selectedSalesOrder.crmSalesorderStatus == 'No Show' || selectedSalesOrder.crmSalesorderStatus == 'Cancel' || selectedSalesOrder.crmSalesorderStatus == 'Void Review')">
                          <a href="javascript:void(0)" (click)="showVoidAppointment('P',selectedSalesOrder.appointmentId)">
                            <i class="void-new"></i>Void
                          </a>
                        </li>


                      </ul>
                    </p-overlayPanel>
                  </td>
                  <td class="table-outer__td appt-so-id" pFrozenColumn>
                    <span class="table-checkbox" pTooltip="{{salesorder.crmSalesOrderAPPId}}">
                        {{salesorder.crmSalesOrderAPPId}}
                    </span>

                  </td>
                  <td class="table-outer__td appt-patient-name" pFrozenColumn>
                    <span class="patient">
                      <a class="text-ellipsis" href="javascript:void(0)"
                        (click)="onView(salesorder.crmSalesOrderId,salesorder.appointmentId)" pTooltip="{{salesorder.crmPatientName}}" tooltipPosition="top">
                        {{salesorder.crmPatientName}}
                      </a>
                      <span class="bright-tree-patient-url">
                        {{salesorder['crmPatientId']}}
                        | {{salesorder['crmPatientBirthdate'] | date:appDateFormat.dateFormat }}
                      </span>
                    </span>

                  </td>
                  <td class="table-outer__td appt-classification" pFrozenColumn><span class="text-ellipsis"
                      pTooltip="{{salesorder.crmClassification}}">{{salesorder.crmClassification}}</span></td>
                  <td class="table-outer__td appt-status" pFrozenColumn>
                    <p [ngClass]="salesorder.crmSalesorderStatus=='Cancel'?'cancel':
                                  salesorder.crmSalesorderStatus=='No Show'?'no-show':
                                  salesorder.crmSalesorderStatus=='Booked'?'upcoming':
                                  salesorder.crmSalesorderStatus=='Complete'?'complete':
                                  salesorder.crmSalesorderStatus=='Void Review'?'voidreview':
                                  salesorder.crmSalesorderStatus=='Void'?'void' :
                                  'ready-for-scheduling'"
                      class="status-block-box">

                      <!-- ::salesorder.schAppointmentStatus=='NoShow'?'no-show':'unreconciled' -->
                    </p>
                  </td>
                  <ng-container *ngFor="let col of columns">
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'crmDoctorName'">
                      <span class="text-ellipsis"
                            pTooltip="{{salesorder.crmDoctorName}}">{{salesorder.crmDoctorName}}</span>
                    </td>
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'crmBranch'">
                      <span class="text-ellipsis" pTooltip="{{salesorder.crmBranch}}">{{salesorder.crmBranch}}</span>
                    </td>
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'dateTimeCreated'">
                      <span class="date-time">
                        {{salesorder['dateTimeCreated'] | date:appDateFormat.dateFormat}}
                      </span>
                    </td>
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'schAppointmentDateTime'">
                      <!--<span class="date-time">
      {{salesorder['schAppointmentDateTime'] | date:appDateFormat.dateFormat}}
    </span>-->
                      <span class="date-time" *ngIf="salesorder['schAppointmentDateTime']">
                        <span>{{salesorder['schAppointmentDateTime'] | date:appDateFormat.dateFormat}}</span>
                        <p>
                          {{salesorder['schAppointmentDateTime'] | date:'shortTime' | lowercase}}<span class="timezone-code">{{salesorder['crmPatientTimeZone'] | timezone}} </span>
                        </p>
                      </span>

                    </td>
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'crmCallBackDateTime'">
                      <span class="date-time dateTimeCreated" *ngIf="salesorder['crmCallBackDateTime']">
                        {{salesorder['crmCallBackDateTime'] | date:appDateFormat.dateFormat}}
                        <p>
                          {{salesorder['crmCallBackDateTime'] | date:'shortTime' | lowercase}}
                          <span *ngIf="salesorder['crmCallBackDateTime'] != null" class="timezone-code">
                            {{salesorder['timeZone'] | timezone}}
                          </span>
                        </p>
                      </span>
                    </td>
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'crmRequestCallBackDate'">
                      <span class="date-time dateTimeCreated" *ngIf="salesorder['crmRequestCallBackDate'] != '0001-01-01T00:00:00'">
                        {{salesorder['crmRequestCallBackDate'] | date:appDateFormat.dateFormat}}
                        <p>
                          {{salesorder['crmRequestCallBackDate'] | date:'shortTime' | lowercase}}
                          <span *ngIf="salesorder['crmRequestCallBackDate'] != null" class="timezone-code">
                            {{salesorder['timeZone'] | timezone}}
                          </span>
                        </p>
                      </span>
                    </td>

                    <td class="table-outer__td" *ngIf="col.visible===true && col.field != 'crmDoctorName' && col.field != 'crmBranch' && col.field != 'dateTimeCreated' && col.field != 'schAppointmentDateTime' && col.field != 'crmCallBackDateTime' && col.field != 'crmRequestCallBackDate'">
                      <span class="text-ellipsis" tooltipPosition="left"
                            pTooltip="{{salesorder[col.field]}}" *ngIf="col.field !='amountDue' && col.field != 'crmClassificaitonduration' && col.field != 'timeZone' && col.field != 'lastCallDate'">{{salesorder[col.field]}}</span>
                      <span class="list-classification-type" *ngIf="col.field=='amountDue'">${{salesorder[col.field] }}</span>
                      <span class="dateTimeCreated" *ngIf="col.field=='crmClassificaitonduration'">{{salesorder[col.field] }} Minutes</span>
                      <span *ngIf="col.field == 'lastCallDate'">
                        {{salesorder['lastCallDate'] | date:appDateFormat.dateFormat}}
                        <p>{{salesorder['lastCallDate'] | date:'shortTime' | lowercase}}</p>
                      </span>
                      <span class="text-ellipsis"
                            *ngIf="col.field=='timeZone'">{{salesorder[col.field] | timezone}} </span>
                    </td>
                  </ng-container>
                </tr>
              </ng-template>

            <ng-template pTemplate="paginatorleft" class="table-pagination">
              <span class="table-pagination__records">
                Total Records : &nbsp;<strong> {{totalRecords}}</strong>
              </span>
            </ng-template>
          </p-table>

          <div class="no-records-found-appointment" *ngIf="!loading && !dataExpressionloading && totalRecords <= 0"
            [attr.colspan]="NsheduledTableDefaltColumns + selectedNonSColumns.length">
            No records found
          </div>
        </div>
      </div>

      <!--</ng-template>-->
    </div>

  </div>

  <!--</p-tabView>-->  
</div>

<div class="loader-block" *ngIf="loading" style="z-index: 99999999 !important;">
  <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff" animationDuration=".8s">
  </p-progressSpinner>
</div>
<div class="loader-block" *ngIf="customloading" style="z-index: 99999999 !important;">
  <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff" animationDuration=".8s">
  </p-progressSpinner>
</div>

<!-- Not Scheduled -->

<p-overlayPanel styleClass="overlayPanel-add-column-popup" class="add-column-popup" #NotScheduledAddColumn>
  <div class="column-display-settings">
    <h3 class="column-display-settings__title">Column Display Settings</h3>
    <div class="column-display-settings__scroll">
      <ul class="quick-link-menu column-display-settings__list" cdkDropList (cdkDropListDropped)="drop($event)">
      <li class="column-display-settings__items" *ngFor="let col of userPreferenceColumn" cdkDrag>
        <span class="column-display-settings__icon" cdkDragHandle>
          <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.8 15.5C1.305 15.5 0.881101 15.3162 0.528301 14.9487C0.175501 14.5812 -0.000598472 14.14 1.52801e-06 13.625C1.52801e-06 13.1094 0.176401 12.6678 0.529201 12.3003C0.882001 11.9328 1.3056 11.7494 1.8 11.75C2.295 11.75 2.7189 11.9337 3.0717 12.3012C3.4245 12.6687 3.6006 13.11 3.6 13.625C3.6 14.1406 3.4236 14.5822 3.0708 14.9497C2.718 15.3172 2.2944 15.5006 1.8 15.5ZM7.2 15.5C6.705 15.5 6.2811 15.3162 5.9283 14.9487C5.5755 14.5812 5.3994 14.14 5.4 13.625C5.4 13.1094 5.5764 12.6678 5.9292 12.3003C6.282 11.9328 6.7056 11.7494 7.2 11.75C7.695 11.75 8.1189 11.9337 8.4717 12.3012C8.8245 12.6687 9.0006 13.11 9 13.625C9 14.1406 8.8236 14.5822 8.4708 14.9497C8.118 15.3172 7.6944 15.5006 7.2 15.5ZM1.8 9.875C1.305 9.875 0.881101 9.69125 0.528301 9.32375C0.175501 8.95625 -0.000598472 8.515 1.52801e-06 8C1.52801e-06 7.48438 0.176401 7.04281 0.529201 6.67531C0.882001 6.30781 1.3056 6.12438 1.8 6.125C2.295 6.125 2.7189 6.30875 3.0717 6.67625C3.4245 7.04375 3.6006 7.485 3.6 8C3.6 8.51562 3.4236 8.95719 3.0708 9.32469C2.718 9.69219 2.2944 9.87562 1.8 9.875ZM7.2 9.875C6.705 9.875 6.2811 9.69125 5.9283 9.32375C5.5755 8.95625 5.3994 8.515 5.4 8C5.4 7.48438 5.5764 7.04281 5.9292 6.67531C6.282 6.30781 6.7056 6.12438 7.2 6.125C7.695 6.125 8.1189 6.30875 8.4717 6.67625C8.8245 7.04375 9.0006 7.485 9 8C9 8.51562 8.8236 8.95719 8.4708 9.32469C8.118 9.69219 7.6944 9.87562 7.2 9.875ZM1.8 4.25C1.305 4.25 0.881101 4.06625 0.528301 3.69875C0.175501 3.33125 -0.000598472 2.89 1.52801e-06 2.375C1.52801e-06 1.85938 0.176401 1.41781 0.529201 1.05031C0.882001 0.682814 1.3056 0.499377 1.8 0.500002C2.295 0.500002 2.7189 0.683751 3.0717 1.05125C3.4245 1.41875 3.6006 1.86 3.6 2.375C3.6 2.89063 3.4236 3.33219 3.0708 3.69969C2.718 4.06719 2.2944 4.25063 1.8 4.25ZM7.2 4.25C6.705 4.25 6.2811 4.06625 5.9283 3.69875C5.5755 3.33125 5.3994 2.89 5.4 2.375C5.4 1.85938 5.5764 1.41781 5.9292 1.05031C6.282 0.682814 6.7056 0.499377 7.2 0.500002C7.695 0.500002 8.1189 0.683751 8.4717 1.05125C8.8245 1.41875 9.0006 1.86 9 2.375C9 2.89063 8.8236 3.33219 8.4708 3.69969C8.118 4.06719 7.6944 4.25063 7.2 4.25Z" fill="#B0A3EF"/>
          </svg>            
        </span>
        <div class="column-display-settings__text">
          <!-- <p-inputSwitch (onChange)="AddNonSColumnInTable($event,col.fieldNo)" [(ngModel)]="col.visible"></p-inputSwitch> -->
          <p-checkbox  name="columns" [binary]="true" [(ngModel)]="col.preferenceVisible" inputId="{{col.fieldNo}}"/>
          <label for="{{col.fieldNo}}">{{col.header}}</label>
          <!-- {{ col.header }} -->
        </div>
        <!--<a href="javascript:void(0)" (click)="AddNonSColumnInTable(col.fieldNo)"> {{ col.header }}</a>-->
      </li>
    </ul>
    </div>
  <div class="column-display-settings__buttons">
    <button class="btn btn--primary" (click)="AddNonSColumnInTable($event,userPreferenceColumn);NotScheduledAddColumn.hide()">Save Changes</button>
    <button class="btn btn--secondary" (click)="CancelNonSColumn($event, NotScheduledAddColumn);">Cancel</button>
  </div>
</div>
</p-overlayPanel>

<!-- Scheduled -->
<p-overlayPanel class="add-column-popup" #ScheduledTableColumn>
  <ul class="quick-link-menu appointments">
    <li *ngFor="let col of dynamicColumns">
      <p-inputSwitch (onChange)="AddColumnInTable($event,col.fieldNo)" [(ngModel)]="col.visible"></p-inputSwitch>
      {{ col.header }}
      <!--<a href="javascript:void(0)" (click)="AddColumnInTable(($event,col.fieldNo)"> {{ col.header }}</a>-->
    </li>
  </ul>
</p-overlayPanel>

<p-dialog [(visible)]="displayCancelAppointment" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer cancel-appointment">
    <h2>Cancel Appointment</h2>
    <div class="schedulecall">
      <form class="form" [formGroup]="formCancel" autocomplete="off">
        <div class="schedulecall">
          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Reason</label>
              <p-select class="form__dropdown" [options]="cancellationReasonsResponseModel" formControlName="reason"
                          placeholder="Select Reason" optionLabel="salesOrderVoidReason" filter="true"></p-select>

              <div *ngIf="formCancelSubmitted && fCancel.reason.errors" class="invalid-feedback-error">
                <span *ngIf="fCancel.reason.errors.required || fCancel.reason.errors.whitespace">
                  {{validationMessages.reason.required}}
                </span>

              </div>
            </div>
          </div>
          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Comment</label>

              <textarea class="form__textarea" pInputTextarea formControlName="reasonComments"
                        maxlength="100"></textarea>
              <!-- <div *ngIf="formCancelSubmitted && fCancel.reasonComments.errors" class="invalid-feedback-error">
                <span *ngIf="fCancel.reasonComments.errors.required || fCancel.reasonComments.errors.whitespace">
                  {{validationMessages.reasonComments.required}}
                </span>
              </div> -->

            </div>
          </div>
          <div class="col">
            <div class="check receive-reminder wip-state-will-not-update form__checkbox-outer">
              <p-checkbox name="groupnamecancel" label="If box checked, the WIP State will not be updated in Brightree"
                          [(ngModel)]="isBrightreeSystemAppUpdate" binary="true" (onChange)="onBTSelect($event)" [ngModelOptions]="{standalone: true}"
                          inputId="cancelAppointmentCheckbox">
              </p-checkbox>
              <label for="cancelAppointmentCheckbox" class="form__checkbox-label">If box checked, the WIP State will not be updated in Brightree</label>
            </div>
          </div>
          <div class="appointment-calcel-btn">
            <button class="btn btn--primary" (click)="cancelAppointment()">Submit</button>
            <a href="javascript:void(0)" class="btn btn--secondary" (click)="hideAppointmentpopup()">Cancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>

<!-- Void Appointment popup -->
<p-dialog [(visible)]="displayVoidAppointment" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer cancel-appointment">
    <h2>Void Appointment</h2>
    <div class="schedulecall">
      <form class="form" [formGroup]="formVoidAppointment" autocomplete="off">
        <div class="schedulecall">

          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Reason</label>
              <p-select class="form__dropdown" [options]="voidReasonsResponseModel" formControlName="voidReason"
                          placeholder="Select Reason" optionLabel="salesOrderVoidReason" filter="true"></p-select>
              <div *ngIf="formVoidAppointmentSubmitted && fVoid.voidReason.errors" class="invalid-feedback-error">
                <span *ngIf="fVoid.voidReason.errors.required || fVoid.voidReason.errors.whitespace">
                  {{validationMessages.voidReason.required}}
                </span>

              </div>
            </div>
          </div>
          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Comment</label>
              <textarea class="form__textarea" pInputTextarea formControlName="voidReasonComments"
                        maxlength="100"></textarea>
              <!-- <div *ngIf="formVoidAppointmentSubmitted && fVoid.voidReasonComments.errors"
                   class="invalid-feedback-error">
                <span *ngIf="fVoid.voidReasonComments.errors.required || fVoid.voidReasonComments.errors.whitespace">
                  {{validationMessages.voidReasonComments.required}}
                </span>
              </div> -->
            </div>
          </div>
          <div class="col">
            <div class="check receive-reminder wip-state-will-not-update form__checkbox-outer">
              <p-checkbox name="groupnamevoid" label="If box checked, the WIP State will not be updated in Brightree"
                          [(ngModel)]="isBrightreeSystemAppUpdate" binary="true" (onChange)="onBTSelect($event)" [ngModelOptions]="{standalone: true}"
                          inputId="cancelAppointmentCheckbox">
              </p-checkbox>
              <label for="cancelAppointmentCheckbox" class="form__checkbox-label">If box checked, the WIP State will not be updated in Brightree</label>
            </div>
          </div>
          <div class="call-popup-appointment">
            <button class="btn btn--primary" (click)="voidAppointment(voidFrom)">Submit</button>
            <a href="javascript:void(0)" class="btn btn--secondary" (click)="cancelVoidAppointment()">Cancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>
